import { useAppSelector } from 'store/store';
import { ROLE_TENANT_OPERATOR } from 'shared/permissions/roles';

export function IsTechnicianOrAbove({ children }) {
  const groups = useAppSelector((state) => state.auth.groups);
  if (groups && !groups.includes(ROLE_TENANT_OPERATOR)) return children;
}
